import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  withStyles, ListItem, ListItemIcon, ListItemText,
} from '@material-ui/core';
import { actions } from '../../../../store/nav';
import { icons, styles } from './Icons';

export function onClickHandler(url, primaryText, navItem, onNavItem, history) {
  if (url.substring(0, window.location.pathname.length) === window.location.pathname) {
    history.push(url.substring(window.location.pathname.length + 1, url.length));
  } else {
    window.location.assign(url);
  }
  navItem({
    url,
    primaryText,
  });
  onNavItem({
    url,
    primaryText,
  });
}

export function NavLinkImpl({
  primaryText,
  url,
  icon,
  depth,
  classes,
  navItem,
  onNavItem,
  history,
}) {
  return (
    <ListItem
      disableGutters
      component="a"
      href={url}
      className={classes.listItem}
      style={{ paddingLeft: `${depth * 10}px` }}
      onClick={() => onClickHandler(url, primaryText, navItem, onNavItem, history)}
    >
      <ListItemIcon className={classes.icon}>{icons[icon]}</ListItemIcon>
      <ListItemText
        primary={primaryText}
        disableTypography
        classes={{
          root: classes.text,
        }}
      />
    </ListItem>
  );
}

const navLinkProps = {
  primaryText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    listItem: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
  depth: PropTypes.number.isRequired,
  navItem: PropTypes.func.isRequired,
  onNavItem: PropTypes.func.isRequired,
};

export { navLinkProps };

NavLinkImpl.propTypes = navLinkProps;

const mapDispatchToProps = {
  navItem: actions.navItem,
};

export default withRouter(connect(
  undefined,
  mapDispatchToProps,
)(withStyles(styles)(NavLinkImpl)));
